import { NotesToRestaurant } from 'restaurantAdmin/components/notesToRestaurant/NotesToRestaurant';
import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import type { OccupantType } from 'restaurantAdmin/reservations/apiHelpers';
import { Button, ButtonVariants } from '@components/button/Button';
import { isReservation } from '../../apiHelpers';
import { useFetchOccupantDetails } from '../../hooks/useFetchOccupantDetails';
import { useSeatReservation } from '../../hooks/useSeatReservation';
import { useServiceSearchParams } from '../../hooks/useServiceSearchParams';
import { SeatingSelectedTables } from '../../SeatingSelectedTables';
import { useReservationServiceSelectedSeatingContext } from '../../state/ReservationServiceSelectedSeatingContext';
import { HeaderBar } from '../HeaderBar';
import styles from './SeatReservationGuestDrawer.scss';
import { getFullName } from '@shared/utils/formatName';

export const SeatReservationGuestDrawer = () => {
  const { id: restaurantId } = useRestaurant();
  const { occupantId, occupantType, navigateBack } = useServiceSearchParams();
  const { occupant } = useFetchOccupantDetails({
    id: occupantId as string,
    type: occupantType as OccupantType,
  });
  const { seatReservation, reseatReservation } = useSeatReservation({
    restaurantId,
  });
  const { selectedFloorPlanTables } =
    useReservationServiceSelectedSeatingContext();
  if (!occupant || !isReservation(occupant)) {
    return null;
  }
  const occupantIsSeated = Boolean(occupant?.seatedTableName);

  const handleSeatingGuest = () => {
    if (!selectedFloorPlanTables.length) return;

    if (occupantIsSeated) {
      reseatReservation(selectedFloorPlanTables, occupant);
    } else {
      seatReservation(selectedFloorPlanTables, occupant);
    }
  };

  return (
    <div data-testid="seat-reservation-guest-drawer">
      <HeaderBar
        name={getFullName(occupant.guest.firstName, occupant.guest.lastName)}
        guestCount={occupant.guestCount}
        time={occupant.time}
      />
      <div className={styles.container}>
        <div className={styles.lowerLevelContainer}>
          <SeatingSelectedTables floorPlanTables={selectedFloorPlanTables} />
          <Button
            label="Seat Now"
            onClick={handleSeatingGuest}
            variant={ButtonVariants.Primary}
            isDisabled={!selectedFloorPlanTables.length}
          />
          <Button
            label="Cancel Seating"
            onClick={navigateBack}
            variant={ButtonVariants.Tertiary}
          />
          <NotesToRestaurant
            className={styles.section}
            note={occupant.note || 'N/A'}
          />
        </div>
      </div>
    </div>
  );
};
